export default {
  'manualPush.pushName': 'Tên tin nhắn',
  'manualPush.status': 'Trạng thái',
  'manualPush.pushTime': 'Thời gian gửi',
  'manualPush.createUserName': 'Người thao tác',
  'manualPush.createTime': 'Thời gian thao tác',
  'manualPush.opt': 'Thao tác',
  'manualPush.status.standby': 'Chờ gửi',
  'manualPush.status.sending': 'Đang gửi',
  'manualPush.status.send': 'Đã gửi',
  'manualPush.detail': 'Chi tiết',
  'manualPush.add': 'Gửi thực tế',
  'manualPush.modalTitle.create': 'Thêm gửi thực tế',
  'manualPush.selectMember': 'Chọn thành viên',
  'manualPush.allMembers': 'Tất cả thành viên',
  'manualPush.partialMembers': 'Thành viên',
  'manualPush.agent': 'Đạilý',
  'manualPush.memberImport': 'Nhập tài liệu',
  'manualPush.member': 'Thành viên',
  'manualPush.selectLanguage': 'Chọn ngôn ngữ',
  'manualPush.languagePlaceholder': 'Vui lòng chọn',
  'manualPush.pleaseSelectLanguage': 'Vui lòng chọn ngôn ngữ',
  'manualPush.sendTitle': 'Tiêu đề gửi',
  'manualPush.pushContent': 'Nội dung đẩy',
  'manualPush.jumpPath': 'Đường dẫn chuyển',
  'manualPush.siteStatus': 'Công tắc đẩy tin nhắn nội bộ',
  'manualPush.siteStatus.open': 'Bật',
  'manualPush.siteStatus.close': 'Tắt',
  'manualPush.pleaseSelectSiteStatus': 'Vui lòng chọn công tắc đẩy tin nhắn nội bộ',
  'manualPush.siteType': 'Loại tin nhắn nội bộ',
  'manualPush.pleaseSelectSiteType': 'Vui lòng chọn loại tin nhắn nội bộ',
  'manualPush.siteType.system': 'Tin hệ thống',
  'manualPush.siteType.promos': 'Tin khuyến mãi',
  'manualPush.siteType.platform': 'Tin nền tảng',
  'manualPush.pleaseInputPushName': 'Vui lòng nhập tên tin nhắn',
  'manualPush.pleaseInputSendTitle': 'Vui lòng nhập tiêu đề gửi',
  'manualPush.pleaseInputPushContent': 'Vui lòng nhập nội dung đẩy',
  'manualPush.pleaseInputMembers': 'Vui lòng nhập tài khoản thành viên',
  'manualPush.pleaseEnter': 'Vui lòng nhập',
  'manualPush.max50Characters': 'Trong vòng 50 ký tự',
  'manualPush.max500Characters': 'Trong vòng 500 ký tự',
  'manualPush.enterMemberAccounts': 'Vui lòng nhập tài khoản thành viên, phân cách nhiều tài khoản bằng dấu phẩy',
  'manualPush.enterAgentAccounts': 'Vui lòng nhập tài khoản đại lý, phân cách nhiều tài khoản bằng dấu phẩy',
  'manualPush.pleaseInputAgents': 'Vui lòng nhập tài khoản đại lý',
  'manualPush.excelFile': 'Tệp Excel',
  'manualPush.pleaseUploadExcelFile': 'Vui lòng tải lên tệp Excel',
  'manualPush.fileSizeLimit': 'Kích thước tệp không được vượt quá 10MB',
  'manualPush.clickToUpload': 'Nhấp để tải lên',
  'manualPush.excelFileFormat': 'Hỗ trợ định dạng .xlsx và .xls',
  'manualPush.createSuccess': 'Tạo thành công',
  'manualPush.createFailed': 'Tạo thất bại',
  'manualPush.formValidationFailed': 'Xác thực biểu mẫu thất bại',
  'manualPush.downloadSample': 'Tải xuống mẫu',
  'manualPush.sampleFileDownloaded': 'Đã tải xuống tệp mẫu',
  'manualPush.uploadInstructions': 'Hướng dẫn tải lên',
  'manualPush.instruction1': 'Từ cột thứ hai của tệp Excel trở đi nên là tài khoản thành viên',
  'manualPush.instruction2': 'Kích thước tệp không được vượt quá 10MB',
  'manualPush.instruction3': 'Hỗ trợ định dạng .xlsx và .xls',
  'manualPush.membersList': 'Thành viên nhận push',
  'manualPush.membersCount': 'thành viên',
  'manualPush.reportDetail': 'Chi tiết báo cáo push',
  'manualPush.pushStatus': 'Trạng thái push',
  'manualPush.pushStatus.success': 'Push thành công',
  'manualPush.pushStatus.failed': 'Push thất bại',
  'manualPush.pushStatus.pending': 'Chờ push',
  'manualPush.failureReason': 'Lý do thất bại',
  'manualPush.date': 'Ngày',
  'manualPush.operator': 'Người vận hành',
  'manualPush.sendUserCount': 'Số lượng người dùng gửi',
  'manualPush.pushSuccessToFailed': 'Push thành công/thất bại',
  'manualPush.pushOpenCount': 'Số lượng mở push',
  'manualPush.siteMessageSwitch': 'Công tắc tin nhắn nội bộ',
  'manualPush.memberType': 'Loại thành viên',
  'manualPush.memberType.specify': 'Thành viên được chỉ định',
  'manualPush.memberType.agent': 'Đại lý',
  'manualPush.memberType.import': 'Nhập tài liệu',
  'manualPush.memberType.all': 'Tất cả thành viên',
  'manualPush.pushOpenRate': 'Tỷ lệ mở push',
};
